import Axios from 'axios';
import moment from 'moment';

import config from '../config/config';

import { generateAndSetNewToken } from '../firebase/firebase';

const URI = config.URI;
const DEFAULT_HEADER = { headers: { 'Content-Type': 'application/json' } };
const EXPIRE_MINUTES = 55;
const GET = 'get';
const POST = 'post';

const isTokenExpire = () => {
  if (!localStorage.tokenGenerationTime) return true;
  const diff = moment.duration(moment().diff(moment(new Date(localStorage.tokenGenerationTime))));
  const duration = diff.asMinutes();
  console.log('LOGIN_DURATION: ', duration);
  return duration > EXPIRE_MINUTES;
};

const calling = (url, method, data) => {
  Axios.defaults.headers.common['firebase-auth-token'] = localStorage.token;
  if (method === POST) {
    return Axios.post(url, data, DEFAULT_HEADER).then((response) => {
      return response.data;
    });
  }
  return Axios.get(url, { params: data }, DEFAULT_HEADER).then((response) => {
    return response.data;
  });
};

const callApi = (url, method, data) => {
  if (!localStorage.token) return Promise.reject();
  if (!isTokenExpire()) return calling(url, method, data);
  return generateAndSetNewToken()
    .then(() => { return calling(url, method, data); });
};

export const loadUser = () => {
  const url = `${URI}/api/auth`;
  return callApi(url, GET);
};
export function login(data) {
  const url = `${URI}/api/auth`;
  return callApi(url, GET, data);
}

export function signIn(data) {
  const url = `${URI}/api/auth/signin`;
  return callApi(url, GET, data);
}

export function getData() {
  const url = `${URI}/`;
  const data = {};
  return callApi(url, GET, data);
}

export function setPlan(data) {
  const url = `${URI}/api/plans`;
  return callApi(url, POST, data);
}

export function addTask(data) {
  const url = `${URI}/api/tasks`;
  return callApi(url, POST, data);
}

export function addTasks(tasks) {
  const url = `${URI}/api/tasks/add`;
  return callApi(url, POST, { tasks });
}

export function addTaskTemplate(data) {
  const url = `${URI}/api/taskTemplate`;
  return callApi(url, POST, data);
}

export function addMultiTemplate(data) {
  const url = `${URI}/api/multiTemplate`;
  return callApi(url, POST, data);
}

export function editMultiTemplate(data) {
  const url = `${URI}/api/multiTemplate/edit`;
  return callApi(url, POST, data);
}

export function fetchMultiTemplates() {
  const url = `${URI}/api/multiTemplate`;
  return callApi(url, GET);
}

export function getPlan(data) {
  const url = `${URI}/api/plans`;
  return callApi(url, GET, data);
}

export function getUserPlan(data) {
  const url = `${URI}/api/planassignment/${data._id}`;
  return callApi(url, GET, data);
}

export function getTaskTypes(data) {
  const url = `${URI}/api/taskTypes`;
  return callApi(url, GET, data);
}

export function getLearnExercises(data) {
  const url = `${URI}/api/learnExercise`;
  return callApi(url, GET, data);
}

export function getVideoExercises() {
  const url = `${URI}/api/video-exercise`;
  return callApi(url, GET);
}

export function getVideoTypeExercises() {
  const url = `${URI}/api/video-exercise/get-video-types`;
  return callApi(url, GET);
}

export function getVideoUrlTypeExercises() {
  const url = `${URI}/api/video-exercise/get-video-url-types`;
  return callApi(url, GET);
}

export function insertOrUpdateVideoExercise(data) {
  const url = `${URI}/api/video-exercise/insert-or-update`;
  return callApi(url, POST, data);
}

export function deleteVideoExercise(data) {
  const url = `${URI}/api/video-exercise/delete`;
  return callApi(url, POST, data);
}

export function getPracticeExercises() {
  const url = `${URI}/api/practiceExercise`;
  return callApi(url, GET);
}

export function getQuizes() {
  const url = `${URI}/api/quiz`;
  return callApi(url, GET);
}

export function getAssessments() {
  const url = `${URI}/api/assessment`;
  return callApi(url, GET);
}

export function fetchTaskTemplates(data) {
  const url = `${URI}/api/taskTemplate`;
  return callApi(url, GET, data);
}

export function fetchTaskTemplatePages(data) {
  const url = `${URI}/api/taskTemplate/pages`;
  return callApi(url, GET, data);
}

export function editTaskTemplate(data) {
  const url = `${URI}/api/taskTemplate/edit`;
  return callApi(url, POST, data);
}

export function deleteTaskTemplate(data) {
  const url = `${URI}/api/taskTemplate/delete`;
  return callApi(url, POST, data);
}

export function fetchTasks(planId) {
  const url = `${URI}/api/tasks/fetchTasks`;
  return callApi(url, POST, { planId });
}

export function fetchSingleDayTasks(data) {
  const url = `${URI}/api/tasks/get-single-day-task`;
  return callApi(url, GET, data);
}

export function getPlanDays(data) {
  const url = `${URI}/api/tasks/get-plan-days`;
  return callApi(url, GET, data);
}

export function updateTasks(task) {
  const url = `${URI}/api/tasks/insert-or-update`;
  return callApi(url, POST, task);
}

export function fetchCompletedTasks(data) {
  const url = `${URI}/api/taskcomplete/user/${data._id}`;
  return callApi(url, GET, data);
}

export function updateTask(task) {
  const url = `${URI}/api/tasks/updateTask`;
  return callApi(url, POST, task);
}

export function fetchUser(field) {
  const url = `${URI}/api/users`;
  return callApi(url, POST, { field });
}

export function fetchAssignedUsers(therapist) {
  const url = `${URI}/api/therapist/assign`;
  return callApi(url, GET, { therapist });
}

export function fetchTherapists(field) {
  const url = `${URI}/api/therapist/search`;
  return callApi(url, GET, { field });
}

export function getAllTherapists() {
  const url = `${URI}/api/therapist/`;
  return callApi(url, GET);
}

export function assignUsersToTherapists(data) {
  const url = `${URI}/api/therapist/assign`;
  return callApi(url, POST, { data });
}

export function fetchAllUsers() {
  const url = `${URI}/api/users`;
  return callApi(url, GET);
}

export function assignPlan(userId, planId) {
  const url = `${URI}/api/planAssignment`;
  return callApi(url, POST, { userId, planId });
}

export function deleteTask(taskId) {
  const url = `${URI}/api/tasks/delete`;
  return callApi(url, POST, { taskId });
}

export function addCallType(data) {
  const url = `${URI}/api/callType/insert`;
  return callApi(url, POST, data);
}
export function editCallType(data) {
  const url = `${URI}/api/callType/edit`;
  return callApi(url, POST, data);
}

export function getCallTypes() {
  const url = `${URI}/api/callType`;
  return callApi(url, GET);
}

export function addCallSlot(data) {
  const url = `${URI}/api/callSlot/insert`;
  return callApi(url, POST, data);
}
export function editCallSlot(data) {
  const url = `${URI}/api/callSlot/edit`;
  return callApi(url, POST, data);
}
export function deleteCallSlot(id) {
  const url = `${URI}/api/callSlot/delete`;
  return callApi(url, POST, { id });
}

export function getCallSlots() {
  const url = `${URI}/api/callSlot`;
  return callApi(url, GET);
}

export function getModerators() {
  const url = `${URI}/api/moderator/get-all`;
  return callApi(url, GET);
}

export function addDashboardUser(data) {
  const url = `${URI}/api/dashboarduser/insert`;
  return callApi(url, POST, data);
}

export const insertOrUpdateSpeechSession = (formdata) => {
  const url = `${URI}/api/speechtherapistsession/insert-or-update`;
  return callApi(url, POST, formdata);
};

export const getSpeechSession = () => {
  const url = `${URI}/api/speechtherapistsession/get`;
  return callApi(url, GET);
};

export function addTherapist(formdata) {
  const url = `${URI}/api/therapist`;
  return callApi(url, POST, formdata);
}

export function getOffers() {
  const url = `${URI}/api/payment-order/get-offer`;
  return callApi(url, GET);
}

export function updateOffer(formdata) {
  const url = `${URI}/api/payment-order/update-offer`;
  return callApi(url, POST, formdata);
}

export function createOffer(formdata) {
  const url = `${URI}/api/payment-order/create-offer`;
  return callApi(url, POST, formdata);
}

export function updateTherapist(formdata) {
  const url = `${URI}/api/therapist/update`;
  return callApi(url, POST, formdata);
}

export function fetchAllTherapist() {
  const url = `${URI}/api/therapist`;
  return callApi(url, GET);
}

export function syncTasks() {
  const url = `${URI}/api/tasks/sync-days-tasks`;
  return callApi(url, GET);
}
